'use client'
import * as React from 'react'
import type { UseRefinementListProps } from 'react-instantsearch'

import { SearchableFilters } from '@web/components/content-api/search-page/utils'
import { useSearchPageContext } from '@web/components/algolia/providers/content-api-search-page-provider'
import { SidebarFilter } from './sidebar-filter'

const sortOrder = [
  'PRODUCT_FORMAT_SQUARE_1_1',
  'PRODUCT_FORMAT_PORTRAIT_9_16',
  'PRODUCT_FORMAT_PORTRAIT_2_3',
  'PRODUCT_FORMAT_PORTRAIT_4_5',
  'PRODUCT_FORMAT_LANDSCAPE_3_2',
  'PRODUCT_FORMAT_LANDSCAPE_16_9',
]

export function OrientationSidebarFilter({
  header,
  showLessText,
  showMoreText,
  mapFormatToLabel,
}: {
  header: string
  showMoreText: string
  showLessText: string
  mapFormatToLabel: Map<string, string>
}) {
  const { expanded } = useSearchPageContext()
  const transformOrientationItems: UseRefinementListProps['transformItems'] = items => {
    return items
      .toSorted((a, b) => sortOrder.indexOf(a.label) - sortOrder.indexOf(b.label))
      .map(item => {
        return {
          ...item,
          label: mapFormatToLabel.get(item.label) || '',
        }
      })
  }

  //eslint-disable-next-line react-hooks/exhaustive-deps
  const memoedTransformOrientationItems = React.useCallback(transformOrientationItems, [])

  return (
    <SidebarFilter
      isExpanded={expanded ? expanded.includes(SearchableFilters.ORIENTATION) : undefined}
      showLessText={showLessText}
      showMoreText={showMoreText}
      attribute={`${SearchableFilters.ORIENTATION}`}
      header={header}
      transformItems={memoedTransformOrientationItems}
    />
  )
}
